const STORAGE_KEY = 'cobracalc_highscores';

export function getHighScores() {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function saveHighScore(entry) {
  const scores = getHighScores();
  scores.push({
    name: entry.name,
    score: entry.score,
    difficulty: entry.difficulty,
    operations: entry.operations,
    numberType: entry.numberType,
    duration: entry.duration,
    date: new Date().toISOString()
  });
  scores.sort((a, b) => b.score - a.score);
  const top10 = scores.slice(0, 10);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(top10));
  return top10;
}

export function isHighScore(score) {
  const scores = getHighScores();
  if (scores.length < 10) return true;
  return score > scores[scores.length - 1].score;
}
